export default __webpack_public_path__ + "static/media/PartsImportSample.13f61b5e.xlsx";